import React from 'react';
import Styles from './cardStyle.module.scss';

type BorderSide = 'left' | 'right' | 'top' | 'bottom' | 'all';

type Props = {
  children: string | JSX.Element | JSX.Element[];
  className?: string;
  bgColor?: string;
  border?: boolean;
  borderSide?: BorderSide;
  borderColor?: string;
};

const Card = ({ children, className, bgColor, border = false, borderSide = 'all', borderColor = '#474646' }: Props) => {
  const borderStyle =
    border === true
      ? borderSide === 'all'
        ? { border: `1px solid ${borderColor}` }
        : {
            borderStyle: 'solid',
            borderColor,
            borderTopWidth: borderSide === 'top' ? '1px' : '0',
            borderRightWidth: borderSide === 'right' ? '1px' : '0',
            borderBottomWidth: borderSide === 'bottom' ? '1px' : '0',
            borderLeftWidth: borderSide === 'left' ? '1px' : '0',
          }
      : {};

  return (
    <div
      className={`${Styles['card']} ${className}`}
      style={{
        ...(bgColor ? { background: bgColor } : {}),
        ...borderStyle,
      }}
    >
      {' '}
      {children}
    </div>
  );
};
export default Card;
